import { RootState } from "@/store";
import { FC, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { LoadingAnimation } from "@/components/LoadingAnimation";

const Dashboard: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isAuthenticating = useSelector((store: RootState) => store.auth.isAuthenticating);

  useEffect(() => {
    //Quan fem el dashboard potser podem canviar això

    // Serveix per redirigir quan 
    if (!isAuthenticating) {
      navigate(t("common:url.invoices"));
    }
  }, [isAuthenticating]);

  return <LoadingAnimation />;
}

export default Dashboard;